module.exports = __webpack_public_path__ + "assets/img/66e8294706515c291ff6b2f35c6b0a5c.png";